import { FieldInfoGroupField, HiddenField } from '@app/common/configurable-wizards';

import { AddressFields, AddressItemFields, AddressTypes } from '../types';

import { ContactSettingsData } from '../contexts/SettingFieldsContext';

import { findField } from './subFieldsFinder';
import { MappedSubFields } from './subFieldsMapper';

// checks that address removing is allowed
export const canRemoveAddress = (field: FieldInfoGroupField) => {
  if (field.id in AddressItemFields) {
    return !!field.subFields?.find((subField) => {
      const entity = subField as HiddenField;

      return entity?.id === 'CanRemove' && entity?.sValue === 'true';
    });
  }

  return false;
};

// checks that address editing is allowed
export const canEditAddress = (
  fieldMeta: MappedSubFields,
  permissions: ContactSettingsData['permissions'],
) => {
  const type = AddressTypes[fieldMeta.Type?.value as keyof typeof AddressTypes];

  switch (type) {
    case AddressTypes.Mailing:
      return !permissions.readonlyGroups.includes(AddressFields.MailingAddressList);
    case AddressTypes.MilitaryMailing:
      return !permissions.readonlyGroups.includes(AddressFields.MailingAddressList);
    case AddressTypes.Physical:
      return !permissions.readonlyGroups.includes(AddressFields.AddressList);
    default:
      return true;
  }
};

/**
 * Сhecks that mailing address can be added
 *
 * Mailing address can be added when:
 * - have not a mailing address
 * - mailing address group is enabled
 * - editing is allowed directly
 */
export const canAddMailingAddress = (
  field: FieldInfoGroupField,
  permissions: ContactSettingsData['permissions'],
) => {
  const mailingAddressField = findField([field], (subField) => {
    const entity = subField as HiddenField;

    return entity.id === 'Type'
      && (entity.sValue === AddressTypes[AddressTypes.Mailing]
        || entity.sValue === AddressTypes[AddressTypes.MilitaryMailing])
      ? subField
      : null;
  });

  return (
    !mailingAddressField
    && permissions.enabledGroups.includes(AddressFields.MailingAddressList)
    && !permissions.readonlyGroups.includes(AddressFields.MailingAddressList)
  );
};
